<ng-template #settingsTemplate>
    <app-tool-setting label="Waarden" class="slider-groups">
        <div class="slider-group">
            <app-range-slider [max]="9" [(range)]="rangeModel.H" label="H"></app-range-slider>
            <app-range-slider [max]="9" [(range)]="rangeModel.T" label="T"></app-range-slider>
        </div>
        <div class="slider-group">
            <app-range-slider [max]="9" [(range)]="rangeModel.E" label="E"></app-range-slider>
        </div>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg id="Laag_1"
         data-name="Laag 1"
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 145 97.25"
         style="height: 150px"
    >
        <defs>
            <style>.hteD-1{fill:#eaf4fb;}.hteD-2{fill:#1d1d1b;}.hteD-3{fill:none;stroke:#0090c9;stroke-width:1.5px;}.hteD-4{font-size:28px;font-family:UniversLTStd, Univers LT Std;}</style>
        </defs>
        <title>DBS_HTE_schema</title>
        <rect class="hteD-1"
              x="1"
              y="1.25"
              width="200"
              height="48" />
        <path class="hteD-2"
              d="M72,36.13V18.29H65.19V15.91H81.51v2.38H74.74V36.13Z"
              transform="translate(0 -0.75)" />
        <path class="hteD-2"
              d="M114.89,15.91h12.68v2.38h-9.88v6.3h9.41V27h-9.41v6.72H127.8v2.46H114.89Z"
              transform="translate(0 -0.75)" />
        <path class="hteD-2"
              d="M19.72,15.91v8.68h9.6V15.91h2.8V36.13h-2.8V27h-9.6v9.13h-2.8V15.91Z"
              transform="translate(0 -0.75)" />
        <line class="hteD-3"
              x1="48.49"
              y1="1.25"
              x2="48.49"
              y2="97.25" />
        <line class="hteD-3"
              x1="96.66"
              y1="1.25"
              x2="96.66"
              y2="97.25" />
        <line class="hteD-3"
              x1="1"
              y1="49.75"
              x2="145"
              y2="49.75" />
        <line class="hteD-3"
              x1="1"
              y1="0.75"
              x2="145"
              y2="0.75" />
        <text class="hteD-4"
              transform="translate(113.22 84.77)">{{rangeModel.E}}</text>
        <text class="hteD-4"
              transform="translate(64.22 84.77)">{{rangeModel.T}}</text>
        <text class="hteD-4"
              transform="translate(16.22 84.77)">{{rangeModel.H}}</text>
    </svg>
</ng-template>

